import axios from "axios";
import * as Signature from "./signature";

const signatureId = process.env.REACT_APP_SIGNATURE_TRANSAKSIKEUANGAN_ID || "";
const signatureKey =
  process.env.REACT_APP_SIGNATURE_TRANSAKSIKEUANGAN_KEY || "";
const signatureSecret =
  process.env.REACT_APP_SIGNATURE_TRANSAKSIKEUANGAN_SECRET || "";
const baseUrl = process.env.REACT_APP_URL_API_KATALOG_TRANSAKSIKEUANGAN || "";

const request = axios.create({
  baseURL: baseUrl,
});

const logs = async (query) => {
  const queryParams = Object.keys(query)
    .filter((paramKey) => query[paramKey] !== "")
    .reduce((prev, current) => ({ [current]: query[current], ...prev }), {});
  const queryParamsUrl = objectToQueryParams(queryParams);
  const url = queryParamsUrl ? `/logs?${queryParamsUrl}` : "/logs";
  const signature = Signature.generate(
    signatureId,
    signatureKey,
    signatureSecret,
    baseUrl + url
  );

  return await request.get(url, {
    headers: {
      "Content-Type": "application/json",
      Signature: signature,
    },
  });
};

const repost = async (id) => {
  const body = { id: id };
  const url = "/send";
  const signature = Signature.generate(
    signatureId,
    signatureKey,
    signatureSecret,
    baseUrl + url
  );

  return await request.post(url, body, {
    headers: {
      "Content-Type": "application/json",
      Signature: signature,
    },
  });
};

const objectToQueryParams = (obj) => {
  return Object.entries(obj)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value.map((v) => `${key}=${encodeURIComponent(v)}`).join("&");
      } else {
        return `${key}=${encodeURIComponent(value)}`;
      }
    })
    .filter((v) => v !== "")
    .join("&");
};

export { logs, repost };
